import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';

import { PaymentOverdueComponent } from '../../../shared/components/payment-overdue/payment-overdue.component';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { STORAGE_ENUM } from '../../enums/storage.enum';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PasswordModule,
    ButtonModule,
    InputTextModule,
    ToastModule,
  ],
  providers: [MessageService, DialogService],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  public loginForm: FormGroup;
  private _authService = inject(AuthService);
  private _localStorageService = inject(LocalStorageService);
  private _router = inject(Router);
  private _dialogService = inject(DialogService);

  public logoPestware = '/img/pestforce-logo.png';

  constructor(
    private _messageService: MessageService,
    private _formBuilder: FormBuilder
  ) {
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  public onSubmit(event: Event) {
    event.preventDefault();

    if (this.loginForm.valid) {
      const email = this.loginForm.get('email')?.value;
      const password = this.loginForm.get('password')?.value;

      this._authService.login(email, password).subscribe({
        next: (res) => {
          this._localStorageService.set(STORAGE_ENUM.TOKEN, res.data.access_token);
          this._localStorageService.set(STORAGE_ENUM.CUSTOMER, res.data.customer);
          this._localStorageService.set(STORAGE_ENUM.USER, res.data.user);
          this._localStorageService.set(STORAGE_ENUM.PORTAL_USER_ID, res.data.portal_user_id);
          this._localStorageService.set(STORAGE_ENUM.COMPANY, res.data.company);

          this._router.navigate(['/']);
        },
        error: (error) => {
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al iniciar sesión. Comprueba tus credenciales e intenta de nuevo.'
          });

          if (error.error && error.error.message && error.error.message.includes('Cuenta suspendida')) {
            const dialog = this._dialogService.open(PaymentOverdueComponent, {
              header: "",
              modal: true,
              width: '75%',
              styleClass: 'responsive-modal',
              closable: true,
              draggable: false,
              maximizable: false,
              resizable: true,
              closeOnEscape: true,
              dismissableMask: true,
            });

            dialog.onClose.subscribe((res) => {
              //
            });
          }
        }
      });
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  public hasErrors(field: string, typeError: string) {
    return this.loginForm.get(field)?.hasError(typeError) && this.loginForm.get(field)?.touched;
  }
}
